import * as React from 'react';
import { Form, Text, FormValues, FormErrors, FormApi } from 'react-form';
import { BaseFormProps, BaseFormState } from '../../../interfaces';
import { ValidationService, TenantDataService } from '../../../services';
import { Tenant } from '../../../models';
import { observer, inject } from 'mobx-react';
import { ServiceStore } from '../../../stores';
import { PonderaEditModal } from '../../../components';

interface FormProps extends BaseFormProps {
    ServiceStore?: ServiceStore;
}

interface FormState extends BaseFormState {
    tenants: Tenant[];
    showDescriptionModal: boolean;
}

@inject('ServiceStore') @observer
export class ScoreCardGroupCharacteristicForm extends React.Component<FormProps, FormState> {
    private vs = new ValidationService();
    private tenantDataService: TenantDataService;
    private formApi: FormApi;

    constructor(props: BaseFormProps) {
        super(props);

        this.state = {
            canSubmit: true,
            formErrors: {},
            tenants: [],
            showDescriptionModal: false
        };

        this.props.defaultValues.surveyReportTypes = this.props.defaultValues.surveyReportTypes || [];

        this.tenantDataService = new TenantDataService(this.props.ServiceStore!.notificationService);

        this.validateErrors = this.validateErrors.bind(this);
        this.validateSuccess = this.validateSuccess.bind(this);
    }

    componentDidMount() {
        this.tenantDataService.getAll().then((tenants: Tenant[]) => {
            this.setState({ tenants: tenants });
        });
    }

    // Validation methods
    validateErrors(values: FormValues) {
        const { name } = values;
        let formErrors: any = {};

        if (name || name === '') {
            if (!this.vs.required(name)) {
                formErrors.name = 'Name is required.';
            } else if (!this.vs.cannotBeEmpty(name!)) {
                formErrors.name = 'Name cannot be blank.';
            }
        }

        return formErrors;
    }

    validateSuccess(values: FormValues, errors: FormErrors) {
        return errors;
    }
    // end of validation stuff

    getModalComponent = () => {
        const modalProps = {
            show: this.state.showDescriptionModal === true,
            onHide: (data: string) => {
                this.setState({showDescriptionModal: false});
                this.formApi.setValue(`desc`, data);
                this.forceUpdate();
            },
            title: `Score Card Characteristic Description`,
            content: this.formApi.values[`desc`],
        };

        return <PonderaEditModal {...modalProps} />;
    }

    setFormApi = (api: FormApi) => {
        this.formApi = api;
    }

    public render() {
        const { canSubmit, formErrors } = this.state;
        
        return (
            <Form
                defaultValues={this.props.defaultValues}
                onSubmit={submittedValues => this.props.submit(submittedValues)}
                validateError={this.validateErrors}
                validateSuccess={this.validateSuccess}
                getApi={this.setFormApi}
            >
                {formApi => (
                    <form onSubmit={formApi.submitForm} id="entityForm">
                        <div className="form-group">
                            <label htmlFor="name">Name *</label>
                            <Text className="form-control" field="name" id="name" />
                            {formErrors.name && <span className="help-block error-text">{formErrors.name}</span>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">Sort</label>
                            <Text className="form-control" field="sort" id="sort" />
                            {formErrors.name && <span className="help-block error-text">{formErrors.name}</span>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="name">Description</label>
                            <br />
                            <a className="btn btn-default" onClick={() => { this.setState({showDescriptionModal: true}); }}>View/Edit</a>
                            {this.getModalComponent()}
                        </div>

                        <button type="submit" className="btn btn-primary" disabled={!canSubmit}>Save</button>
                    </form>
                )}
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCardGroupCharacteristic/ScoreCardGroupCharacteristicForm.tsx